// import * as React from "react";
// import Box from "@mui/material/Box";
// import DataTools from "../../DataTools/DataTools";

// const boxStyle = {
//   width: "290px",
//   height: "207px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   flexWrap: "wrap",
//   border: "1px solid black",
// };

// const imageStyle = {
//   width: "100%",
//   maxWidth: "280px",
//   maxHeight: "200px",
// };

// const titleStyle = {
//   width: "100%",
//   maxWidth: "280px",
//   textAlign: "center",
// };

// const HRPacker = () => {
//   const displayedIds = [2];
//   const displayedTools = DataTools.filter((tool) =>
//     displayedIds.includes(tool.id)
//   );

//   return (
//     <div style={{ width: "100%" }}>
//       <Box
//         sx={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "center",
//           gap: 2,
//         }}
//       >
//         {displayedTools.map((tool, index) => (
//           <Box key={index}>
//             <Box style={boxStyle}>
//               <img
//                 src={tool.image}
//                 alt={`Tool ${tool.id}`}
//                 style={imageStyle}
//               />
//             </Box>
//             <Box style={titleStyle}>
//               <p>{tool.title}</p>
//             </Box>
//           </Box>
//         ))}
//       </Box>
//     </div>
//   );
// }
// export default HRPacker

import * as React from "react";
import Box from "@mui/material/Box";
import DataTools from "../../DataTools/DataTools";
import { Link } from "react-router-dom";
import "../../SidebarMenu/categoryStyle.css";

const HRPacker = () => {
  const displayedIds = [2];
  const displayedTool = DataTools.find((tool) =>
    displayedIds.includes(tool.id)
  );

  return (
    <Box className="main-box">
      <Box>
      <Link
          to={`/tool/details/2`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
        <Box className="box">
          <img
            src={displayedTool.image}
            alt={`Tool ${displayedTool.id}`}
            className="image"
          />
        </Box>
        <Box className="title">
          <p>{displayedTool.title}</p>
        </Box>
        </Link>
      </Box>
    </Box>
  );
};
export default HRPacker;
